import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=3e8500c0"
import script from "./Tarjeta.vue?vue&type=script&lang=ts"
export * from "./Tarjeta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports